export const authUrl = `${process.env.REACT_APP_DOC_STORAGE_URL}/api/Authenticator/Authenticate` // isProd ? `${prodRoot}assets/NAIT/DiViewerAuthenticator/DiViewerAuthenticator/authentication/index` : "http://localhost:64930/authentication/Index";

// eslint-disable-next-line
Array.prototype.selectMany = function (fn) {
  return this.map(fn).reduce(function (x, y) { return x.concat(y); }, []);
};